
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"32","viewBox":"0 0 32 32","width":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.632 5.12c-.002 0-.003.003-.005.003a.634.634 0 00-.321.102c-.01.007-.025.005-.04.013-.01.007-.01.019-.02.026-.02.016-.045.025-.065.044a.646.646 0 00-.143.229l-.003.005c-.002.005.002.011 0 .016a.703.703 0 00-.04.203V26.24c0 .076.02.149.045.219a.61.61 0 00.143.234c.02.02.045.03.07.047.01.006.01.018.02.024s.025.004.035.011c.1.062.211.107.331.107h30.719l.015-.003a.622.622 0 00.312-.102c.015-.008.03-.004.045-.013.01-.008.015-.023.025-.031.02-.015.04-.022.06-.039a.635.635 0 00.141-.224c.002-.004.005-.006.01-.011.003-.01 0-.021.003-.031a.602.602 0 00.035-.188V5.761a.644.644 0 00-.187-.453c-.02-.022-.051-.031-.076-.049-.005-.006-.01-.016-.015-.021-.01-.006-.02-.005-.03-.011a.632.632 0 00-.333-.107h-.003zM2.4 6.401h27.188L15.994 17.729l-2.659-2.216h-.003zm-1.127.719L11.929 16 1.273 24.88zm29.44 0v17.755l-10.654-8.878zm-17.792 9.711l2.664 2.216a.632.632 0 00.406.154h.003a.622.622 0 00.214-.042.639.639 0 00.196-.112l2.664-2.216 10.521 8.768H2.401z"}})])
          )
        }
      }
    